import React from 'react';

import { StyledMicrosoftLoginButton } from '../../components/lib/SocialButton/MicrosoftButton';
import { MicrosoftLoginButtonHOC } from './MicrosoftLoginButtonHOC';

export const MicrosoftLoginButton = MicrosoftLoginButtonHOC((props) => (
  <StyledMicrosoftLoginButton {...props} title="Sign up with Microsoft" />
));
